import { Accordion, AccordionDetails, AccordionSummary, Box, Checkbox, FormControlLabel, IconButton, Typography } from "@mui/material"
// import CustomCard from "./CustomCard"
import luciLogo from "../../../assets/luciLogo2.png"
import poweredBy from "../../../assets/poweredBy.svg"
// import { customTheme as theme } from "../../../theme/customTheme"
import { makeStyles } from "@mui/styles";
import {   timeStampToDateTime, timeStampToDayString, timeStampToFormatTimeZone,  } from "../../../utils/commonServices";
import "@fontsource/rubik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import usePermissions from "../../../hooks/usePermissions";
import { PERMISSION } from "../../../constants/constants";
import { updateCreationState } from "../../../redux/eventCreationSlice";
import CustomButton from "../../../components/CustomButton";
import { updateState } from "../../../redux/commonSlice";
import CustomTooltip from "../../../components/CustomTooltip";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import useCustomTheme from "../../../theme/useCustomTheme";
import { updateProjectState } from "../../../redux/projectSlice";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useState } from "react";
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CustomCard from "../../events/components/CustomCard";
import { updateReviewState } from "../../../redux/reviewSlice";
import useRevisionActions from "../useRevisionActions";
import Thumbnail from "./Thumbnail";

const useStyles = makeStyles((theme) => ({
 fontWeightNormal:{
  fontWeight: 'normal'
 }, 
fontWeight:{
  fontWeight:600
},
rubik:{
  fontFamily:'Rubik'
}

}));

const EditingCyclesCard = (props) => {

  const commonReducer = useSelector((state)=> state.root.commonReducer)
  // const event = commonReducer.events?.find((event) => event.id == commonReducer.production_event_id)
  const themeReducer = useSelector((state) => state.root.themeReducer);
  const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
  const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [hasPermission] = usePermissions()
  const [theme ] = useCustomTheme()
  const [selectedVideos, setSelectedVideos] = useState([]);

  const {event, projectId, orgId} = props
  const [expanded, setExpanded] = useState(0); // Default to the first accordion
  const {getRevisionLogsList, getEditingCyclesList} = useRevisionActions()
     

  const [selectedThumbnail, setSelectedThumbnail] = useState(null); // Track selected thumbnail

  const handleThumbnailClick = (index) => {
    setSelectedThumbnail(index); // Toggle selection
  };

  useEffect(()=> {
  if(!!projectId && !!orgId) {
    getEditingCyclesList({event_id: projectId, organisation_id: orgId}, selectEditedVideoToReview)
  } else {
    getEditingCyclesList({event_id: commonReducer?.production_event_id, organisation_id:commonReducer?.selected_organisation?.id}, selectEditedVideoToReview)
  }
  
},[commonReducer?.production_event_id, projectId, orgId])


  const handleAccordionChange = (panelIndex) => (_, isExpanded) => {
    setExpanded(isExpanded ? panelIndex : 0);
    // const tempInternalRevisionList = reviewEventReducer?.editing_cycles_list[panelIndex]?.internal_revisions
    // dispatch(updateReviewState({internal_revisions_list: tempInternalRevisionList}))
    setSelectedVideos([])
  };

  const handleVideoSelect = (videoId) => {
    setSelectedVideos((prevSelected) => {
      if (prevSelected.includes(videoId)) {
        return prevSelected.filter((id) => id !== videoId); // Deselect video
      } else if (prevSelected.length < 2) {
        return [...prevSelected, videoId]; // Select video if fewer than 2 are selected
      } else {
        // Replace the first selected video if a third is selected
        return [prevSelected[1], videoId];
      }
    });
   
  };


  useEffect(()=>{
    dispatch(updateReviewState({selected_video_ids: selectedVideos}))
  },[selectedVideos])

  // console.log(selectedVideos, 'usestaet')
  // console.log(reviewEventReducer?.selected_video_ids, 'redux--')

  // const handleVideoSelect = (videoId) => {
  //   setSelectedVideos((prevSelected) => {
  //     if (prevSelected.includes(videoId)) {
  //       return prevSelected.filter((id) => id !== videoId); // Deselect video
  //     } else if (prevSelected.length < 2) {
  //       return [...prevSelected, videoId]; // Select video if fewer than 2 are selected
  //     }
  //     return prevSelected; // Do nothing if already 2 selected
  //   });
  // };

  // const brandLogo = window.localStorage.getItem('brand_logo_url')
  const brandLogo = themeReducer?.brand_logo

  const classes = useStyles();




  const openDocumentClickHandler = async ()=>{

      const documentUrl = commonReducer?.event_details?.note_file_url; 
      window.open(documentUrl, '_blank');
  }

 

  const selectEditedVideoToReview =(revision)=>{
    dispatch(updateReviewState({selected_video_url: revision?.video_url, internal_revision_id: revision?.id}))
    revision?.id && getRevisionLogsList({internal_revision_id: revision?.id})
    setSelectedThumbnail(revision?.id); // Toggle selection
  }

  const onThumbnailClick =(revision)=>{
    selectEditedVideoToReview(revision) ; 
    dispatch(updateReviewState({show_video_checklist:false}))
  }


  return (
    <CustomCard className='rubik' style={{ height:'100%', padding:0 , '& .MuiCardContent-root:last-child':{paddingBottom:0}, }} >
      <Box className="rubik" sx={{height:'100%', display:'flex', flexDirection:'column' }}>
        {/* <Box className="rubik flex j-center a-center" sx={{ width: '100%', marginTop:{xs:'25px',sm:'20px',md:'7%', lg: '8%',xl:'8%'}, marginBottom:{xs:'25px',sm:'20px',md:'3%',lg:'4%',xl:'4%'},}} >
          <Box  width='35%'>
           <img src={brandLogo !== null ? brandLogo : luciLogo} width='100%' onClick={()=>navigate('/dashboard', {replace: true})} style={{cursor:'pointer'}}/>
           {
                brandLogo !== null && <Box textAlign='right'><img src={poweredBy}  width='50%'/></Box> 
            }
            </Box>
        
        </Box> */}

        {reviewEventReducer?.editing_cycles_list?.length > 0 && reviewEventReducer?.editing_cycles_list?.map((item, index) => (
        <Accordion
          key={index}
          expanded={expanded === index}
          onChange={handleAccordionChange(index)}
          disableGutters
         
          sx={{
            
            // '& .MuiAccordionSummary-root': {
            //   backgroundColor: expanded === index ? '#00d74450' : 'transparent',
            // },
            // '& .MuiAccordionDetails-root': {
            //   backgroundColor: expanded === index ? '#00d74450' : 'transparent',
            // },
          
          }}
        >
          <AccordionSummary  expandIcon={<ExpandMoreIcon/>}>
            <Typography sx={{fontSize:{xs:'14px',lg:'16px',xl:'20px'}}}>{`Edit Round ${item.version}`}</Typography>
          </AccordionSummary>
          <AccordionDetails style={{ boxShadow: "none" }} sx={{overflowY:'scroll',  maxHeight:{md: '72vh', lg: '75vh', xl:'78vh'}}}>
            <Box>
              {/* {item?.internal_revisions?.map((revision, idx) => (
                <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: '16px'}}>
                 
                <Box
                onClick={() => selectEditedVideoToReview(revision)}
                  key={idx}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: '16px',
                    // backgroundColor:'red',
                    height:'80px',
                    width:'150px',
                    borderRadius:'5px',
                    cursor:'pointer',
                    border: selectedVideos.includes(revision.id)
                        ? '2px solid #1976d2' // Highlight selected videos
                        : '2px solid #dedede',
                  }}
                > 
                  <Typography sx={{fontSize: '16px', fontWeight: '600'}}>{`Version: ${revision.version}`}</Typography>
                {!!revision?.thumbnail_url  ? <img width='100%' height='100%' src={revision?.thumbnail_url} alt={'test thumbnail'} style={{borderRadius:'3px'}}/> : <img width='100%' height='100%' src="/testImg2.jpg" alt={'test thumbnail'} style={{borderRadius:'3px'}}/>}
                </Box>
                <Checkbox
                size="small"
                 checked={selectedVideos.includes(revision.id)} 
                 onChange={() => handleVideoSelect(revision.id)} 
                />
              </Box>
              ))} */}
              {item?.internal_revisions?.map((revision, idx) => (
                <Thumbnail 
                revision={revision} 
                item={item} 
                selectedVideos={selectedVideos}   
                isSelected={selectedThumbnail === revision.id} 
                onClick={() => onThumbnailClick(revision)} 
                handleVideoSelect={handleVideoSelect}
                onChange={(e) =>{  e.stopPropagation(); e.preventDefault(); handleVideoSelect(revision.id)}} 
               />
              ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}


            {selectedVideos.length === 2 && (
              <Box className='flex col j-end a-center' sx={{flex: 2, mb:1}} mt={{xs:1, md:1,xl:2}}>
              <CustomButton 
              btnText='Compare'
              onClick={()=>  dispatch(updateProjectState({compare_videos_popup : true})) }
              type='button'    
              color='secondary'
              variant='contained'
              style={{
                borderRadius: '5px',
                border: "none",
                textTransform:'none',
              
                }}

              sx={{fontSize:{xs:'8px',sm:'9px',lg:'11px',xl:'16px'},  fontWeight:600, height:{xs:'18px',sm:'18px',lg:'22px',xl:"36px"}, width: '100%', maxWidth: {xs:'120px', xl:'180px'} , fontFamily:'Rubik'}}
            />
            </Box>
        ) }
      </Box>
    </CustomCard>
  )
}

export default EditingCyclesCard